// extracted by mini-css-extract-plugin
export var dividerLine = "_79-3";
export var itemImage = "_79-9";
export var lightDivider = "_79-4";
export var modalContent = "_79-5";
export var modalContentCompact = "_79-6";
export var productCard = "_79-a";
export var productImage = "_79-b";
export var productImageCompact = "_79-7";
export var productImagePlaceholder = "_79-c";
export var productImagePlaceholderCompact = "_79-8";
export var progressBarBackground = "_79-1";
export var progressBarContainer = "_79-0";
export var progressBarFill = "_79-2";